import { format, parse } from "date-fns";

export const extractUniqueDatesWithEventIDs = (events) => {
  const datesMap = new Map();

  events.forEach((event) => {
    const startDate = new Date(event.start_date * 1000);
    const endDate = event.end_date > event.start_date ? new Date(event.end_date * 1000) : new Date(event.start_date * 1000 + 1);

    for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
      const formattedDate = format(d, "MMMM do");
      const eventObject = {
        id: event.ID,
        title: event.post_title,
        speakers: event?.speakers ? event.speakers.split(",").map((speaker) => speaker.trim()) : [""],
      };

      if (datesMap.has(formattedDate)) {
        datesMap.get(formattedDate).events.push(eventObject);
      } else {
        datesMap.set(formattedDate, {
          day: formattedDate,
          events: [eventObject],
        });
      }
    }
  });

  const sortedDates = [...datesMap.values()].sort((a, b) => {
    const dateA = parse(a.day, "MMMM do", new Date());
    const dateB = parse(b.day, "MMMM do", new Date());
    return dateA - dateB;
  });

  return sortedDates;
};
